<div class="profile-container">
  <div class="profile-body">
    <div class="row">
      <div class="col-md-3">
        <div class="full-height">
          <div class="profile-detail-card">
            <div class="profile-img">
              <div class="profile-img-wrapper">
                <img src="assets/img/namik.jpg" alt="profilePicture" />
              </div>
            </div>
            <div class="user-detail">
              <span>Namik Arifoğlu</span>
              <span>info@namikarifoglu.com</span>
            </div>
          </div>
          <div class="body-separator"></div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="full-height">
          <tabset>
            <tab heading="Profile Detail" id="tab1">
              <form>
                <div class="form-body">
                  <div class="form-group row">
                    <div class="col-10">
                      <h3 class="form-title">1. Çalışan Bilgileri</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="full-name" class="col-md-3 col-form-label"
                      >Tam Adı</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="full-name"
                        type="text"
                        value="Namık Arifoğlu"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="email" class="col-md-3 col-form-label">{{
                      "email" | translate
                    }}</label>
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="email"
                        type="text"
                        value="info@namikarifoglu.com"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="company" class="col-md-3 col-form-label"
                      >Şirket</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="company"
                        type="text"
                        value="Kalem Yazılım"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="phone" class="col-md-3 col-form-label"
                      >Telefon Numarası</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="phone"
                        type="text"
                        value="+9053563522862"
                      />
                    </div>
                  </div>
                  <div class="form-seperator"></div>

                  <div class="form-group row">
                    <div class="col-10">
                      <h3 class="form-title">2. Adres Bilgileri</h3>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="address" class="col-md-3 col-form-label"
                      >Ülke</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="address"
                        type="text"
                        value="Türkiye"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="city" class="col-md-3 col-form-label">İl</label>
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="city"
                        type="text"
                        value="İstanbul"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="county" class="col-md-3 col-form-label"
                      >İlçe</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="county"
                        type="text"
                        value="Fatih"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="post-code" class="col-md-3 col-form-label"
                      >Posta Kodu</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="post-code"
                        type="text"
                        value="34015"
                      />
                    </div>
                  </div>

                  <div class="form-seperator"></div>
                  <div class="form-group row">
                    <div class="col-10">
                      <h3 class="form-title">3. Sosyal Medya Hesapları</h3>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label for="linkedin" class="col-md-3 col-form-label"
                      >Linkedin</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="linkedin"
                        type="text"
                        value="https://www.linkedin.com/in/namikarifoglu"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="facebook" class="col-md-3 col-form-label"
                      >Facebook</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="facebook"
                        type="text"
                        value="www.facebook.com/namikarifoglu"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="twitter" class="col-md-3 col-form-label"
                      >Twitter</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        id="twitter"
                        type="text"
                        value="www.twitter.com/namikarifoglu"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="instagram" class="col-md-3 col-form-label"
                      >Instagram</label
                    >
                    <div class="col-md-8">
                      <input
                        class="form-control form-control-sm"
                        type="text"
                        id="instagram"
                        value="www.instagram.com/namikarif"
                      />
                    </div>
                  </div>
                </div>
                <div class="m-portlet__foot m-portlet__foot--fit">
                  <div class="m-form__actions">
                    <div class="row">
                      <div class="col-md-3"></div>
                      <div class="col-md-8">
                        <button type="submit" class="btn btn-greenish">
                          Bilgileri Güncelle</button
                        >&nbsp;&nbsp;
                        <button type="reset" class="btn btn-default">
                          Vazgeç
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </tab>
            <tab heading="Basic Title 1">Basic content 1</tab>
            <tab heading="Basic Title 2">Basic content 2</tab>
          </tabset>
        </div>
      </div>
    </div>
  </div>
</div>
